import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import getCartQuery from './query'
import { IGetCart, IGetCartVariables } from './types'

/**
 * Hook declaration to obtain a get cart lazy query.
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
export const useLazyGetCart = (
  options?: Omit<
    LazyQueryHookOptions<IGetCart, IGetCartVariables>,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<IGetCart, IGetCartVariables>(getCartQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export default useLazyGetCart
